import Text, { TEXT_VARIANT } from '@pixum/text';
import { flattenI18n } from '../../utils/i18nConstants/flatternI18n';
import type { NewsletterTextBlockProps } from './types';

/**
 * Renders the localized newsletter benefits and privacy information.
 *
 * @param constants - Localized newsletter copy.
 * @param privacyPolicyLink - URL for the privacy policy.
 */
export function NewsletterTextBlock({ constants, privacyPolicyLink }: NewsletterTextBlockProps) {
  const goodInformed = flattenI18n(constants.i18n_good_informed);
  const exclusiveBenefits = flattenI18n(constants.i18n_exclusive_benefits);
  const protectionRules = flattenI18n(constants.i18n_protection_rules);
  const unsubscriptionAlwaysPossible = flattenI18n(constants.i18n_unsubscription_always_possible);

  return (
    <>
      <Text variant={TEXT_VARIANT.TITLE_3}>{goodInformed}</Text>
      <Text variant={TEXT_VARIANT.BODY}>
        {`${exclusiveBenefits} `}
        <span className="newsletter__link-block">
          <a href={privacyPolicyLink} title={protectionRules}>
            {protectionRules}
          </a>
          , {unsubscriptionAlwaysPossible}.
        </span>
      </Text>
    </>
  );
}
